import React, {useState} from "react";
import { Button, Column, Columns, Field, Modal, Section } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";
import useTypeaheadInput from "../../hooks/useTypeaheadInput";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";

export default function MultipleEditModal({
  open,
  setOpen,
  selected,
  saveSelected,
  trackingOptions,
  nominalCodes,
  trackingObjects,
  codeObjects,
  paymentTypes,
  paymentTypeObjects
}) {
  const [invoiceDate, invoiceDateInput, setInvoiceDate] = useInput({
    type: "date",
    label: "Invoice Date"
  });
  const [dateOrdered, dateOrderedInput, setDateOrdered] = useInput({
    type: "date",
    label: "Date Ordered"
  });
  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Invoice Number"
  });
  const [supplier, supplierInput, setSupplier] = useTypeaheadInput({
    label: "Supplier",
    placeholder: "Search Supplier",
    searchUrl: "/api/contacts?contact_type=SP"
  });
  const [nominalCode, setNominalCode] = useState();
  const [trackingOption, setTrackingOption] = useState();
  const [paymentType, setPaymentType] = useState();

  const onTrackingOptionChange = (e) => {
    setTrackingOption(trackingObjects[e.target.value])
  };

  const onNominalCodeChange = e => {
    setNominalCode(codeObjects[e.target.value])
  };

  const onPaymentTypeChange = e => {
    setPaymentType(paymentTypeObjects[e.target.value])
  }

  const onSave = () => {
    saveSelected(invoiceNumber, dateOrdered, supplier, invoiceDate, trackingOption, nominalCode, paymentType).then(onClose);
  };

  const onClose = () => {
    setOpen(false);
    setInvoiceNumber("");
    setDateOrdered("");
    setSupplier("");
    setTrackingOption(undefined);
    setNominalCode(undefined);
    setPaymentType(undefined);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={onClose} size={"large"}>
      <Modal.Content className={"wider-modal"}>
        <Section style={{ backgroundColor: "white" }}>
          <Columns isMultiline>
            {supplierInput}
            {dateOrderedInput}
            {invoiceNumberInput}
            {invoiceDateInput}
            <Column>
              <TrackingOptionsPicker
                name={"supplier_tracking_option"}
                label={"Tracking Option"}
                value={trackingOption}
                options={trackingOptions}
                blank={true}
                className={"not-small"}
                inlineEdit={false}
                editable={true}
                onChange={onTrackingOptionChange}
              />
            </Column>
            <Column>
              <NominalCodePicker
                name={"supplier_nominal_code"}
                label={"Nominal code"}
                value={nominalCode}
                options={nominalCodes}
                blank={true}
                small={false}
                inlineEdit={false}
                editable={true}
                onChange={onNominalCodeChange}
              />
            </Column>
            <Column>
              <label className="label">Payment Type</label> {/* For some reason if inline edit is false the label will always be blank */}
              <PaymentTypePicker
                name={"payment_type"}
                value={paymentType}
                options={paymentTypes}
                blank={true}
                inlineEdit={false}
                editable={true}
                onChange={onPaymentTypeChange}
              />
            </Column>
          </Columns>
          <Field>
            <p>You are editing {Object.keys(selected).length} parts</p>
          </Field>
          <Button color="success" onClick={onSave}>
            Save
          </Button>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
